//Do Cpr
<template>
  <div>
    <div v-if="$store.getters.deviceSerial" class="col-12 col-lg-6">
      <p class="title">Tulokset</p>
      <CprResult title="Painelutaajuus" ref-unit="x/min" :average-value="parseFloat($store.getters.cprData.cprValues.averageRate).toFixed(1)" :ref-min-value="$store.getters.cprData.referenceValues.minRate" :ref-max-value="$store.getters.cprData.referenceValues.maxRate" :result-value="parseFloat($store.getters.cprData.cprValues.inTargetRate).toFixed(2)" icon="painelutaajuus.png"></CprResult>
      <CprResult title="Painelusyvyys" ref-unit="cm" :average-value="parseFloat($store.getters.cprData.cprValues.averageDepth).toFixed(1)" :ref-min-value="$store.getters.cprData.referenceValues.minDepth" :ref-max-value="$store.getters.cprData.referenceValues.maxDepth" :result-value="parseFloat($store.getters.cprData.cprValues.inTargetDepth).toFixed(2)" icon="painelusyvyys.png"></CprResult>
      <CprResult title="Yhteensä" ref-unit="Molemmat arvot viitearvoissa" :result-value="parseFloat($store.getters.cprData.cprValues.total).toFixed(2)" icon="star.png"></CprResult>
    </div>
    <div v-else class="reloadPrompt">
      <router-link to="/">
        <p class="error title">Jokin meni pieleen.</p>
        <button class="btn-info">Palaa alkuun</button>
      </router-link>
    </div>
  </div>
</template>
<script>
  //<div v-if="$store.getters.cprData" class="jumbotron rounded border-info border">
  //<button @click="cprTrainingReady">Harjoitus valmis</button>
  import CprResult from "./CprResult";
  export default {
    components: {CprResult},
    methods: {
            cprTrainingReady() {
                this.$router.push('home');
            },
        },
    }
</script>

<style>
  .title {
    font-size: 40px;
    margin-bottom: 40px;
  }

  .error {
    color: red;
  }

  .btn-info {
    border-radius: 56px;
    min-width: 150px;
    min-height: 50px;
    font-size: 18px;
    -webkit-box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75);
  }

</style>



// WEBPACK FOOTER //
// src/components/Results/CprResultsView.vue